import React from 'react';

import CssClassName from '../generateCssClassName/CssClassName';

interface Props {
  children: React.ReactNode;
  id: string;
  hideFlag: boolean;
}

const CustomComponentWrapper = ({ children, id, hideFlag }: Props): React.ReactNode => {
  if (id === CssClassName.KIOSK) {
    return hideFlag ? null : children;
  }
  return children;
};

export default CustomComponentWrapper;
